/**
 * 顶栏实时时钟（对齐原型 `#topright .clockbox` / `tickClock()`）。
 *
 * 原型格式：日期 `2026/10/04 周日` + 时间 `18:12:44`。
 * 最终可用文本形如 `2026/10/04 周日 18:12:44`（日期在前，时间在后）。
 *
 * ⚠️ 每秒刷新，组件卸载必须 `clearInterval`，否则会遗留定时器。
 */

import { useEffect, useState } from 'react';

const WEEKDAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'] as const;

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function formatDate(d: Date): string {
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${WEEKDAYS[d.getDay()]}`;
}

function formatTime(d: Date): string {
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export default function Clock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="clockbox" data-testid="topbar-clock">
      <span className="d">{formatDate(now)}</span>{' '}
      <span className="t">{formatTime(now)}</span>
    </div>
  );
}
